/* eslint-disable */
import React, { useContext } from 'react';
import { Grid, Paper } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/authContext';
import {
  forgotHeaderStyle,
  labelStyle,
  paperStyle,
  pLabelStyle,
} from '../styles';
import { Typography } from '@mui/material';
import { AuthPAGES } from '../../constants/pages';
import { PAGES } from '../../../../types/pages';
import { Header } from './components/Header/Header';

const RegisterComplete: React.FC<any> = () => {
  /* States and context declaration */

  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const onGoToDashBoard = async (e: any) => {
    try {
      await authContext.signInOTP(
        authContext.email,
        authContext.passwordAdvance
      );
      navigate(PAGES.landing);
    } catch {
      navigate(AuthPAGES.signIn);
    }
  };

  const onGoToProfile = async (e: any) => {
    try {
      await authContext.signInOTP(
        authContext.email,
        authContext.passwordAdvance
      );
      navigate(AuthPAGES.userProfile);
    } catch {
      navigate(AuthPAGES.signIn);
    }
  };

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
        <Paper elevation={1} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            <Typography>
              <Link
                to=''
                onClick={(e) => {
                  onGoToDashBoard(e);
                }}
                style={pLabelStyle}
              >
                Skip
              </Link>
            </Typography>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default RegisterComplete;
